import { FlowType } from './flow.types';

export const FormViewType = {
  COMPLETED_FORM: 'completedForm',
  FILL_FORM: 'fillForm',
};

export const Field = {
  REGION: 'region',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  PHONE_NUMBER: 'phoneNumber',
  PASSWORD: 'password',
  REPEAT_PASSWORD: 'repeatPassword',
  CONSENT: 'consent',
  VAT_NUMBER: 'vatNumber',
  VAT_COUNTRY_CODE: 'vatCountryCode',
  COMPANY_NAME: 'companyName',
  COMPANY_ADDRESS: 'companyAddress',
  PROSPECT_TYPE: 'prospectType',
};

const VALID_FIELD_ONBORDING = [
  Field.VAT_NUMBER,
  Field.COMPANY_NAME,
  Field.COMPANY_ADDRESS,
];

const VALID_FIELD_REGISTRATION = [
  Field.VAT_NUMBER,
  Field.COMPANY_NAME,
  Field.COMPANY_ADDRESS,
  Field.PROSPECT_TYPE,
];

export const FIELD_TO_VALID_MAP = new Map([
  [FlowType.ONBOARDING, VALID_FIELD_ONBORDING],
  [FlowType.REGISTRATION, VALID_FIELD_REGISTRATION],
]);
